import { render, staticRenderFns } from "./AnalyticsResultChartsOutcomesAdmissionVsDischarge.vue?vue&type=template&id=f5f4c828"
import script from "./AnalyticsResultChartsOutcomesAdmissionVsDischarge.vue?vue&type=script&lang=js"
export * from "./AnalyticsResultChartsOutcomesAdmissionVsDischarge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports